import { useEffect, useState } from 'react';
import { getInfoContentService } from '../../../../../services/customer/infoContentServices';
import useTranslation from '../../../../hooks/translation/useTranslation';

function InfoContentTab({ type }) {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState(null);
  const fetchContent = async () => {
    try {
      const res = await getInfoContentService({ type: `${type}${currentLanguage !== 'ka' ? `-${currentLanguage}` : ''}` });
      if (res.status === 'success') {
        setContent(res.data.content);
      } else {
        setContent(null);
      }
    } catch {
      setContent(null);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [currentLanguage, type]);
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
}

export default InfoContentTab;
